{
  "en": {
    "aiPrivacyNotice": {
      "backToChat": "Back to AI Chat",
      "pupil": {
        "facts": {
          "aiDoesNotKnowYou": "The AI doesn't know you as long as you don't share personal data.",
          "teacherCanSee": "Your teacher can see what you do and who you are."
        },
        "policyLink": "Read more about data protection",
        "rules": {
          "doubtAnswers": "I don't believe everything the AI says.",
          "heading": "Two rules when using the AI:",
          "noPrivateData": "I don't tell the AI my real name or other private things."
        },
        "title": "How to protect your data"
      },
      "teacher": {
        "handling": {
          "detail": "Providers delete requests after 30 days at the latest.",
          "heading": "How your data is handled",
          "text": "No training of AI models."
        },
        "intro": "For a response, fobizz sends your input to the AI service provider you selected.",
        "notTransmitted": {
          "detail": "The provider cannot identify you.",
          "heading": "What we do not transmit",
          "text": "Name, email, user ID, school or IP address."
        },
        "policyLink": "To the full privacy policy",
        "title": "Data usage by AI services",
        "transmitted": {
          "detail": "(Images, audio, PDF, text)",
          "heading": "What we transmit",
          "text": "Your texts and uploaded files"
        }
      }
    }
  }
}
